import { ActionTypes as types } from 'constants';
import config from 'config';
import { Auth, getBearerHeaders } from 'utils';
import { logError } from 'actions';

const log = { component: 'paymentMethods' };

// eslint-disable-next-line max-len
export default (paymentCardId, _logError = logError) => dispatch => {
  const headers = getBearerHeaders();
  headers.set(
    'Accept',
    'application/hal+json; charset=utf-8; version=1.0; profile=jg.donationcollection',
  );
  headers.set(
    'Prefer',
    'return=representation,embed="*|IncludeSelf,NoLinkTransform"',
  );

  const url = `${
    config.donationService.baseUrl
  }/donors/${Auth.getUserGuid()}/wallet/paymentcards/${paymentCardId}`;
  const options = {
    method: 'DELETE',
    headers,
    credentials: 'include',
  };

  const deleteCardPromise = fetch(url, options)
    .then(res => Promise.all([res, res.json()]))
    .then(([res, json]) => {
      if (res.ok) {
        dispatch({
          type: types.DELETE_CARD_SUCCESS,
          payload: json,
        });
        return Promise.resolve(res);
      }
      const error = new Error(res.statusText);
      error.response = json;
      return Promise.reject(error);
    })
    .catch(error => {
      dispatch({ type: types.DELETE_CARD_FAILURE });
      dispatch(
        _logError(types.UPDATE_APP_STATUS_FETCH_ERROR, { ...log, error }),
      );
      return Promise.reject(error);
    });

  dispatch({
    type: types.DELETE_CARD,
  });

  return deleteCardPromise;
};
